import PropTypes from 'prop-types';

// material-ui
import Modal from '@mui/material/Modal';

// project-imports
import FormCustomerAdd from './FormCustomerAdd';
import MainCard from 'components/MainCard';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| CUSTOMER ADD / EDIT ||============================== //

const CustomerModal = ({
  open,
  modalToggler,
  onSubmit,
  customer,
  type = 'patient',
  mode,
  abhaSession
}) => {
  const closeModal = () => {
    localStorage.removeItem('comingFromAppointmentForm');
    modalToggler(false);
  };

  const customerForm = (
    <FormCustomerAdd 
      type={type}
      mode={mode}
      customer={customer || null} 
      closeModal={closeModal}
      handleFormSubmit={onSubmit}
      abhaSession={abhaSession}
    />
  );

  return (
    <Modal
      open={open}
      onClose={closeModal}
      aria-labelledby="modal-customer-add-label"
      aria-describedby="modal-customer-add-description"
      sx={{
        '& .MuiPaper-root:focus': {
          outline: 'none',
        },
      }}
    >
      <MainCard
        sx={{
          width: `calc(100% - 48px)`,
          minWidth: 340,
          maxWidth: 880,
          height: 'auto',
          maxHeight: 'calc(100vh - 48px)',
        }}
        modal
        content={false}
      >
        <SimpleBar
          sx={{
            maxHeight: `calc(100vh - 48px)`,
            '& .simplebar-content': {
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          {customerForm}
        </SimpleBar>
      </MainCard>
    </Modal>
  );
};

CustomerModal.propTypes = {
  open: PropTypes.bool,
  modalToggler: PropTypes.func,
  customer: PropTypes.any,
  type: PropTypes.oneOf(['patient', 'employee']),
  abhaSession: PropTypes.object,
};

export default CustomerModal;
